export enum Operation {
  GreaterThan = 'greaterThan',
  GreaterThanEqual = 'greaterThanEqual',
  LessThan = 'lessThan',
  LessThanEqual = 'lessThanEqual',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
  IsNot = 'isNot',
  HasValue = 'hasValue',
  Contains = 'contains',
  NotContains = 'notContains',
  IsNull = 'isNull',
  OneOf = 'oneOf',
  NoneOf = 'noneOf',
}

// Plz use this only for trigger condition in automations
export enum AutomationOperations {
  IncreasedBy = 'INCREASED_BY',
  DecreasedBy = 'DECREASED_BY',
  ChangedFromTo = 'CHANGED_FROM_TO',
  AddedContainsOneOf = 'ADDED_CONTAINS_ONE_OF',
  RemovedContainsOneOf = 'REMOVED_CONTAINS_ONE_OF',
  BecameEmpty = 'BECAME_EMPTY',
  BecameNotEmpty = 'BECAME_NOT_EMPTY',
  BecameExactly = 'BECAME_EXACTLY',
  BecameNot = 'BECAME_NOT',
  NBecameMoreThan = 'N_BECAME_MORE_THAN',
  NBecameLessThan = 'N_BECAME_LESS_THAN',
  NIncreasedByMoreThan = 'N_INCREASED_BY_MORE_THAN',
  NDecreasedByMoreThan = 'N_DECREASED_BY_MORE_THAN',
  DIncreasedByMoreThan = 'D_INCREASED_BY_MORE_THAN',
  DDecreasedByMoreThan = 'D_DECREASED_BY_MORE_THAN',
  BecameOneOf = 'BECAME_ONE_OF',
  BecameNoneOf = 'BECAME_NONE_OF',
  DeltaTextContains = 'DELTA_TEXT_CONTAINS',
  DIncreasedByExactly = 'D_INCREASED_BY_EXACTLY',
  DIncreasedByLessThan = 'D_INCREASED_BY_LESS_THAN',
  DDecreasedByExactly = 'D_DECREASED_BY_EXACTLY',
  DDecreasedByLessThan = 'D_DECREASED_BY_LESS_THAN',
  TContains = 'T_CONTAINS',
  TDoesNotContain = 'T_DOES_NOT_CONTAIN',
  IsEmpty = 'IS_EMPTY',
  IsNotEmpty = 'IS_NOT_EMPTY',
}

export enum NumberOperationType {
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
  IsNot = 'isNot',
}
